module.exports = __webpack_public_path__ + "img/image_home_03.be22bacb.svg";